import React from "react";
import Footer from "../core/presentations/Footer";
import Header from "../core/presentations/Header";
import { AuthRoutes } from "./AuthRoutes";
import { AuthFacadeProvider } from "./facades/Auth.facade";
import { AuthRepositoryProvider } from "./repository/Auth.repository";
import { AuthServiceProvider } from "./services/Auth.service";

export const Auth = () => {
  return (
    <AuthRepositoryProvider>
      <AuthServiceProvider>
        <AuthFacadeProvider>
          <Header></Header>
          <div className="flex items-center justify-center min-h-screen">
            <div className="hidden p-28 md:p-28 md:w-1/2 md:block">
              <img
                src={require("./../../../../assets/images/svg/signup-infographic.svg")?.default}
              alt=""></img>
            </div>
            <div className="p-8 sm:p-10 md:w-5/12">
              <AuthRoutes />
            </div>
          </div>
          <Footer></Footer>
        </AuthFacadeProvider>
      </AuthServiceProvider>
    </AuthRepositoryProvider>
  );
};
